module.exports = __webpack_public_path__ + "img/table-no-data.c1c7c9bf.png";